function Interpolate() {
	
}

Interpolate.prototype = {
	pos: 0,

	setStart: function(begin) {
		this.begin = begin;
	},

	setEnd: function(end) {
		this.end = end;
	},

	prepareValues: function(a, b) {
		this.a = a;
		this.b = b;
	},

	cosine: function(mu) {
		var dt = (1 - Math.cos(mu * Math.PI)) / 2;
		return (this.a * (1 - dt) + this.b * dt);
	},

	linear: function(mu) {
		return (this.a * (1 - mu) + this.b * mu);
	},

	easeOutCubic: function(mu) {
		var dt = 1 - Math.pow(1 - mu, 3);
		return (this.a * (1 - dt) + this.b * dt);
	},

	easeInCubic: function(mu) {
		var dt = Math.pow(mu, 3);
		return (this.a * (1 - dt) + this.b * dt);
	},

	easeOutElastic: function(mu) {
		const c4 = (2 * Math.PI) / 3;

		var dt = mu === 0
		  ? 0
		  : mu === 1
		  ? 1
		  : Math.pow(2, -10 * mu) * Math.sin((mu * 10 - 0.75) * c4) + 1;

		return (this.a * (1 - dt) + this.b * dt);
	},

	reset: function() {
		this.pos = 0;
	},

	next: function(step) {
		var dt = player.currentFrameTime - player.lastFrameTime;

		this.pos += (dt / (step * 1000));
	},

	calculate: function(method) {
		switch(method) {
			case "easeOutElastic":
				return this.easeOutElastic(this.pos);
			break;
			case "easeInCubic":
				return this.easeInCubic(this.pos);
			break;
			case "easeOutCubic":
				return this.easeOutCubic(this.pos);
			break;
			case "cosine":
				return this.cosine(this.pos);
			break;
			default:
				return this.linear(this.pos);
		}				
	},

	cycle: function(method) {
		this.prepareValues(this.begin, this.end);

		return this.calculate(method);
	},

	cycleProperty: function(prop, method) {
		this.prepareValues(this.begin[prop], this.end[prop]);

		return this.calculate(method);
	}
}